import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const DocumentTextContainer = styled.div`
  * {
    margin: revert;
    padding: revert;
    padding-inline-start: revert;
    list-style: revert;
    color: ${ColorPalette.HEX.OuterSpace};
  }

  * > li {
    margin-bottom: 8px;
  }

  * > b {
    font-weight: 600;
  }

  padding: 12px;
  @media ${({ theme }) => theme.device.mobile} {
    padding: 16px;

    * {
      font-size: 14px;
    }

    * > h4 {
      font-size: 20px;
    }

    * > h3 {
      font-size: 24px;
    }
  }
`;
